import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { AutoCompleteComponent} from '@progress/kendo-angular-dropdowns';
import { GItem } from '@app/cp/shared/models/GItem';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
@Component({
    selector: 'potential-customer-selector',
    templateUrl: './potential-customer-selector.component.html',
    styleUrls: ['./potential-customer-selector.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PotentialCustomerSelectorComponent implements OnInit {
    @ViewChild("searchAC") ac: AutoCompleteComponent;

    @Input() minSearchSize: number = 3;
    @Output() selected: EventEmitter<any> = new EventEmitter<any>();
    data: GItem[];
    constructor(globals: GlobalsService, private svc_data: DQOIService) {

    }
    ngOnInit() {
    }
    filterChange(filter: string) {
        if (filter.toString().length < this.minSearchSize) {
            this.data = [];
            return;
        }
        this.setLoading(true);

        this.svc_data.potentialCustomer_Search(filter).subscribe((data: GItem[]) => {
            this.data = data;
            this.setLoading(false);
        });
    }
    setLoading(loading: boolean) {
            this.ac.loading = loading;
    }
    valueChange(value: any) {
        if (CommonFunctions.hasValue(value)) {

            this.svc_data.getPotentialCustomerFromName(value).subscribe(data => {
                this.svc_data.customerIdChanged(data);
                this.selected.emit(data);
            });
        }
        else {
            this.svc_data.customerIdChanged(null);
            this.selected.emit(null);
        }

    }
}
